import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sparkles, LogOut } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (path) =>
    `text-sm transition-colors ${loc.pathname === path ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`;

  return (
    <header
      className="sticky top-0 z-40 w-full border-b border-border bg-background/60 backdrop-blur-xl"
      data-testid="app-nav"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2.5" data-testid="brand-link">
          <img src="/logo.png" alt="Client Scout" className="h-9 w-9 rounded-lg object-contain" />
          <span className="font-medium tracking-tight text-lg">Client Scout</span>
        </Link>

        {user ? (
          <nav className="flex items-center gap-6">
            <Link to="/dashboard" className={linkCls("/dashboard")} data-testid="nav-dashboard">Dashboard</Link>
            <Link to="/new" className={linkCls("/new")} data-testid="nav-new-list">New List</Link>
            <Link to="/pricing" className={linkCls("/pricing")} data-testid="nav-pricing">Pricing</Link>
            {user.role === "admin" && (
              <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>
            )}
            <Link to="/account" className={linkCls("/account")} data-testid="nav-account">Account</Link>
            <div className="hidden sm:flex items-center gap-2 text-xs px-3 py-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary" data-testid="nav-credits">
              <Sparkles className="w-3 h-3" /> {user.credits === -1 ? "Unlimited" : `${user.credits} credit${user.credits === 1 ? "" : "s"}`}
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => { logout(); nav("/"); }}
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4 mr-1.5" /> Logout
            </Button>
          </nav>
        ) : (
          <nav className="flex items-center gap-5">
            <a href="/#contact" className="text-sm text-muted-foreground hover:text-foreground" data-testid="nav-contact">Contact</a>
            <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground" data-testid="nav-pricing-public">Pricing</Link>
            <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground" data-testid="nav-login">Log in</Link>
            <Button asChild size="sm" className="rounded-full bg-primary hover:bg-[#FF7043] text-white" data-testid="nav-signup">
              <Link to="/register">Get started</Link>
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
}
